export enum DATE_FORMAT {
	TIME_MINUTES_SECONDS = 'mm:ss',
	DATE_VIEW = 'DD.MM.YY',
	DATE_TIME = 'DD.MM.YY HH:mm',
	DAY_MONTH_NAME_YEAR_TIME = 'DD MMM YY HH:mm', //20 лист 24 11:57
	DAY_MONTH_NAME_YEAR = 'DD MMM YY', // 20 лист 24
	DATE_MONTH_YEAR = 'MMM YY', // лист 24
	DATE_FULL = 'DD.MM.YY HH:mm:ss',
}
